<div class="dash-entidad">
  <app-breadcrumb
    [listado]="rutaListado()"
    [etiquetaListado]="labelListado()"
    [titulo]="nombre"
  ></app-breadcrumb>

  <app-page-title
    [title]="nombre"
    [subtitle]="tituloNivel()"
    [icon]="iconoNivel()"
    color="gray"
    padding="0 16px 16px 16px"
    [showActions]="true"
  >
    <button
      irxBoton="secundario"
      actions
      type="button"
      (click)="verSeguimiento()"
      tooltip="Cuántas luminarias ya quedaron con cada perfil mandado desde acá, y por qué faltan las que faltan."
    >
      <mat-icon>track_changes</mat-icon>
      Seguimiento del perfil
    </button>
  </app-page-title>

  <mat-divider></mat-divider>

  <mat-tab-group class="custom-tab-group">
    <!-- Info (dashboard) -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">info</mat-icon>
        <span>Info</span>
      </ng-template>
      <div class="dash-content">
        @if (cargando) {
          <div class="dash-loading">
            <mat-spinner diameter="44"></mat-spinner>
            <p>Cargando dashboard…</p>
          </div>
        } @else if (cantidadLuminarias === 0) {
          <div class="dash-vacio">
            <mat-icon>info</mat-icon>
            <p>No hay luminarias asociadas a esta entidad.</p>
          </div>
        } @else {
          <div class="dashboard-entidad">
            <app-dashboard-filtros>
              <button
                irxBotonIcono
                filtros-acciones
                tooltip="Restaurar el orden original de los paneles"
                (click)="grilla.restaurarOrden()"
              >
                <mat-icon>restart_alt</mat-icon>
              </button>
            </app-dashboard-filtros>

            <!-- Tarjetas de indicador -->
            <div class="stat-cards-fila dashboard-indicadores">
              @for (card of statCards; track $index) {
                <app-stat-card
                  [config]="card"
                  [formatAsNumber]="true"
                  numberFormat="1.0-2"
                ></app-stat-card>
              }
            </div>

            <!-- Grilla de paneles ordenables -->
            <app-dashboard-grilla
              #grilla
              [(items)]="graficos"
              claveOrden="dashboard-entidad-luminarias-orden-graficos"
            >
              <ng-template let-grafico>
                <app-dashboard-panel
                  [titulo]="grafico.titulo"
                  [icono]="grafico.icono"
                >
                  @if (grafico.id === 'consumo') {
                    <app-date-picker
                      panel-acciones
                      mode="monthrange"
                      matTooltip="Período"
                      [maxDate]="hoy"
                      [(ngModel)]="rangoMesesConsumo"
                      (ngModelChange)="onRangoMesesChange($event)"
                    ></app-date-picker>
                  }

                  @if (!graficoListo(grafico.id)) {
                    <div
                      class="dpanel-vacio"
                      [style.min-height]="grafico.altura"
                    >
                      <mat-spinner diameter="36"></mat-spinner>
                      <p>Cargando…</p>
                    </div>
                  } @else if (!tieneDatos(grafico)) {
                    <div
                      class="dpanel-vacio"
                      [style.min-height]="grafico.altura"
                    >
                      <mat-icon>{{ grafico.icono }}</mat-icon>
                      <p>{{ grafico.sinDatos }}</p>
                    </div>
                  } @else {
                    @switch (grafico.tipo) {
                      @case ('bar') {
                        <app-graficos
                          tipo="bar"
                          [series]="obtenerDatosGrafico(grafico.id)"
                          [categorias]="obtenerCategoriasGrafico(grafico.id)"
                          [titulo]="''"
                          tituloEjeX="Rango de horas encendidas"
                          [altura]="grafico.altura"
                          [mostrarLeyenda]="false"
                          [ocultarLabelsEjes]="false"
                        ></app-graficos>
                      }
                      @case ('column') {
                        <app-graficos
                          tipo="column"
                          [series]="obtenerDatosGrafico(grafico.id)"
                          [categorias]="obtenerCategoriasGrafico(grafico.id)"
                          [titulo]="''"
                          tituloEjeX="Mes/Año"
                          tituloEjeY="Consumo total (kWh)"
                          [altura]="grafico.altura"
                          [mostrarLeyenda]="false"
                          [ocultarLabelsEjes]="false"
                        ></app-graficos>
                      }
                      @case ('eventos') {
                        <!-- Auto-consulta sus propios datos -->
                        <app-grafico-eventos-luminarias
                          [idsLuminarias]="idsLuminariasEventos"
                          [titulo]="grafico.titulo"
                          [mostrarTitulo]="false"
                          [altura]="grafico.altura"
                          [card]="false"
                        ></app-grafico-eventos-luminarias>
                      }
                      @default {
                        <!-- pie -->
                        <app-graficos
                          [tipo]="grafico.tipo"
                          [datos]="obtenerDatosGrafico(grafico.id)"
                          [titulo]="''"
                          [altura]="grafico.altura"
                          [mostrarLeyenda]="true"
                          posicionLeyenda="right"
                          [mostrarEtiquetas]="false"
                        ></app-graficos>
                      }
                    }
                  }
                </app-dashboard-panel>
              </ng-template>
            </app-dashboard-grilla>
          </div>
        }
      </div>
    </mat-tab>

    <!-- Historial reportes de estado -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">description</mat-icon>
        <span>Historial reportes de estado</span>
      </ng-template>
      <ng-template matTabContent>
        <app-listado-reportes-genericos
          [entidad]="entidadReporte"
          tipoEntidad="Puesta"
          [tipoValoresReporte]="tiposReporteEstado"
        ></app-listado-reportes-genericos>
      </ng-template>
    </mat-tab>

    <!-- Historial reportes de consumo -->
    @if (tiposReporteConsumo.length) {
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">battery_charging_full</mat-icon>
          <span>Historial reportes de consumo</span>
        </ng-template>
        <ng-template matTabContent>
          <app-listado-reportes-genericos
            [entidad]="entidadReporte"
            tipoEntidad="Puesta"
            [tipoValoresReporte]="tiposReporteConsumo"
          ></app-listado-reportes-genericos>
        </ng-template>
      </mat-tab>
    }
  </mat-tab-group>
</div>
